import { ERROR_CODE } from '@messenger/consts'
import { orderTokenHeaders } from '@/utils/global/orderTokenHeaders'

/**
 * Whether a page or text-box save from this tab was refused because the tab
 * no longer holds access to what it is saving: an edit-link tab whose save
 * the backend answers 403 from an access check (no code, or `FORBIDDEN`), or
 * 404 `NOT_FOUND` from the order record guard (a page whose order is gone).
 * A refusal with any other code says why on its own, the page-gone code and
 * the Lotus funeral home limit among them. Such a save did not complete: a
 * text-box save that writes page by page may have written earlier pages. A tab signed in with a JWT has no link to reopen,
 * so its refusals are never this.
 */
export const isEditAccessLostError = (error: unknown): boolean => {
  const response = (
    error as {
      response?: { status?: number; data?: { code?: string } }
    } | null
  )?.response
  if (Object.keys(orderTokenHeaders()).length === 0) return false
  const code = response?.data?.code
  if (response?.status === 403)
    return code === undefined || code === ERROR_CODE.FORBIDDEN
  return response?.status === 404 && code === ERROR_CODE.NOT_FOUND
}
